// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'calendar-range';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M16.344 2.808H1.656c-.648 0-1.152.504-1.152 1.152v12.384c0 .648.504 1.152 1.152 1.152h14.616c.648 0 1.152-.504 1.152-1.152V3.96c0-.648-.504-1.152-1.08-1.152zM.576 7.344h16.848M5.04 4.464V.576m7.92 3.888V.576' />
    <path d='M7.2 11.016c-.144 0-.288-.144-.288-.288s.144-.288.288-.288m0 .576c.144 0 .288-.144.288-.288s-.144-.288-.288-.288m3.6.576c-.144 0-.288-.144-.288-.288s.144-.288.288-.288m0 .576c.144 0 .288-.144.288-.288s-.144-.288-.288-.288m3.672.576c-.144 0-.288-.144-.288-.288s.144-.288.288-.288m0 .576c.144 0 .288-.144.288-.288s-.144-.288-.288-.288M3.528 14.4c-.144 0-.288-.144-.288-.288s.144-.288.288-.288m0 .576c.144 0 .288-.144.288-.288s-.144-.288-.288-.288M7.2 14.4c-.144 0-.288-.144-.288-.288s.144-.288.288-.288m0 .576c.144 0 .288-.144.288-.288s-.144-.288-.288-.288m3.6.576c-.144 0-.288-.144-.288-.288s.144-.288.288-.288m0 .576c.144 0 .288-.144.288-.288s-.144-.288-.288-.288' />
  </g>
);

export const viewBox = '0 0 18 18';
